import { Box, Container } from '@mui/material';
import Benefits from './components/Benefits';
import CallToAction from './components/CallToAction';
import Faq from './components/Faq';
import PricingCalculator from './components/PricingCalculator';
import Process from './components/Process';

/**
 * The font size to use for titles
 */
export const SectionTitleFontSize = '3em';

/**
 * On this page, the user can learn more about purchasing the training
 */
const PurchaseTraining = () => (
  <Box width="100%">
    <PricingCalculator />
    <Container maxWidth="lg">
      <Process />
    </Container>
    <Benefits />
    <Container maxWidth="lg">
      <Faq />
    </Container>
    <CallToAction />
  </Box>
);

export default PurchaseTraining;
